if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.addToCart = this.productSection.querySelector(
        '.product-info__add-to-cart'
      );
      this.virtualConsultation = document.querySelector('virtual-consultation');

      window.addEventListener('scroll', this.showStickyBar.bind(this));
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    showStickyBar() {
      const scrollY = window.scrollY;
      const productForm = document.querySelector('.product-info__add-to-cart');

      if(productForm) {
        const showBar = scrollY > productForm.offsetTop + productForm.offsetHeight;
        this.classList.toggle('invisible', !showBar);
        this.classList.toggle('sticky-atc-panel--out', !showBar);
      }
    }

    updateVirtualConsultationPosition() {
      const shouldPushUp =
        !document.body.classList.contains('scrolled-to-bottom') &&
        !this.classList.contains('sticky-atc-panel--out');

      if (this.virtualConsultation) {
        // Store initial bottom value if not already saved
        if (!this.initialVCBottom) {
          const computed = getComputedStyle(this.virtualConsultation);
          this.initialVCBottom = computed.bottom || '0px';
        }

        this.virtualConsultation.style.bottom = shouldPushUp
          ? `calc(${this.offsetHeight}px + ${this.initialVCBottom})`
          : this.initialVCBottom;
      }
    }

    handleScroll() {
      const atBottom =
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight;

      document.body.classList.toggle('scrolled-to-bottom', atBottom);

      const stickyPanel = document.querySelector('sticky-atc-panel');
      if (stickyPanel && typeof stickyPanel.updateVirtualConsultationPosition === 'function') {
        stickyPanel.updateVirtualConsultationPosition();
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
